<template>
	<div class="fixmenu">
		<el-row>
			<el-col :span="12" v-loading="isLoading">
				<div class="btn">
					<span>是否开启常见问答</span>
					<el-switch
						:active-value="1"
						:inactive-value="0"
						v-model="menuFlag"
						style="left: 30px"
						@change="changeInfo"
					></el-switch>
				</div>
				<el-card>
					<div v-for="(item, index) in problemlist" :key="index" class="itemcard">
						{{ `*问题${index + 1}` }}
						<span v-if="index === 0" @click="tianjia">
							<i
								class="el-icon-circle-plus-outline"
								style="float: right; cursor: pointer; color: #3da1ff"
							></i>
						</span>
						<span v-else @click="jianshao(index)">
							<i
								class="el-icon-remove-outline"
								style="float: right; cursor: pointer; color: #3da1ff"
							></i>
						</span>
						<el-input
							type="textarea"
							v-model="item.problem"
							@change="changeInfo"
							maxlength="30"
							show-word-limit
						></el-input>
						{{ '*回复' }}
						<el-input
							type="textarea"
							v-model="item.reply"
							@change="changeInfo"
						></el-input>
					</div>
				</el-card>
			</el-col>
			<el-col :span="12">
				<div class="show-data">
					<div class="font" v-for="(item, index) in problemlist" :key="index">
						{{ item.problem }}
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	props: ['bottomFlag', 'fbConfigProblemDTOList'],
	data() {
		return {
			menuFlag: '',
			problemlist: [],
			isLoading: false
		};
	},
	methods: {
		tianjia() {
			if (this.problemlist.length < 5) {
				this.problemlist.push({
					problem: '',
					reply: '',
				});
				this.changeInfo();
			}
		},
		jianshao(index) {
			this.problemlist.splice(index, 1);
			this.changeInfo();
		},
		changeInfo() {
			this.isLoading = true
			this.$emit('changeFixmenu', this.menuFlag, this.problemlist, this.resetLoading);
		},
		resetLoading() {
			this.isLoading = false
		}
	},
	watch: {
		bottomFlag: {
			handler(val) {
				this.menuFlag = val;
			},
		},
		fbConfigProblemDTOList: {
			handler(val) {
				if (!val) return false;
				this.problemlist = val;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.fixmenu {
	margin-left: 60px;
	margin-bottom: 40px;

	.btn {
		margin: 50px 0 80px 0;
		font-size: 14px;
		font-weight: 700;
	}

	.itemcard {
		width: 500px;
		padding: 18px 0;
		font-size: 14px;

		el-input {
			margin: 10px 0;
		}
	}

	.show-data {
		margin: 100px auto;
		width: 570px;
		height: 539px;
		padding: 52px 25px 0;
		background-image: url(../../../assets/menu.png);
		background-size: 100%;
		background-repeat: no-repeat;

		.font {
			margin: 30px 0 0 80px;
			font-size: 16px;
			width: 375px;
			overflow: hidden; //超出的文本隐藏
			text-overflow: ellipsis; //溢出用省略号显示
			white-space: nowrap; //溢出不换行
		}
	}
}
</style>
